import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { MatTable, MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSort } from '@angular/material/sort';
import { SiteAuditService } from '@app/features/site-audit/site-audit.service';
import { FortigatesService } from '@app/features/fortigates/shared/fortigates.service';

@Component({
    selector: 'app-kevlar2-config',
    templateUrl: './kevlar2-config.component.html',
    styleUrls: ['./kevlar2-config.component.scss'],
    standalone: false
})
export class Kevlar2ConfigComponent implements OnInit {

  storeNumber: string = '';
  wan1Interface: any;
  wan1InterfaceLoading: boolean = false;
  gatewayInfo: any;
  gatewayInfoLoading: boolean = false;

  constructor(private fortigatesService: FortigatesService) { }

  ngOnInit() {
  }

  async getConfigItems() {
    await this.getWan1Interface();
    await this.getGatewayInfo();
  }

  getGatewayInfo() {
    this.gatewayInfoLoading = true;
    return this.fortigatesService.getGatewayInfo(this.storeNumber).then((observable) => {
      observable.toPromise().then((response) => {
        this.gatewayInfo = response["message"];
        this.gatewayInfoLoading = false;
      })
    })
  }

  getWan1Interface() {
    this.wan1InterfaceLoading = true;
    return this.fortigatesService.getWan1Interface(this.storeNumber).then((observable) => {
      observable.toPromise().then((response) => {
        // The endpoint returns one entry per FortiGate at the store; a store only
        // ever has one primary circuit, so show the first.
        const wan1Interfaces = response["message"];
        this.wan1Interface = Array.isArray(wan1Interfaces) && wan1Interfaces.length > 0
          ? wan1Interfaces[0]["wan1-interface"]
          : null;
        this.wan1InterfaceLoading = false;
      })
    })
  }

}
